<div class="text-center py-3" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!loading">
  <table class="table">
    <tbody  [appNativeSortableJs]="todos" [sortableOptions]="sortOptions">
      <tr *ngFor="let todo of todos">
        <td style="width: 45%"></td>
        <td [title]="todo.notes" [innerHTML]="todo.name || todo.notes | safeHtml"></td>
      </tr>
    </tbody>
  </table>
  <div class="form-group form-row" *ngIf="matter_id">
    <div class="custom-control custom-checkbox" (click)="showInactive = !showInactive; loadTodos()">
      <input [(ngModel)]="showInactive" [checked]="showInactive" type="checkbox" class="custom-control-input" />
      <label class="custom-control-label">Show Inactive To-Dos</label>
    </div>
  </div>
</div>
